import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import UserDashboard from './components/UserDashboard';
import AdminDashboard from './components/AdminDashboard';
import TeacherDashboard from './components/TeacherDashboard';
import MainTestPage from './components/MainTestPage';
import './App.css';

function AppContent() {
  const location = useLocation();
  const isMainTestPage = location.pathname === '/main-test';

  const routes = (
    <Routes>
      {/* 메인 페이지 - 방문자용 학생 코드 입력 대시보드 */}
      <Route 
        path="/" 
        element={<UserDashboard />} 
      />
      
      {/* 관리자 페이지 */}
      <Route 
        path="/admin" 
        element={<AdminDashboard />} 
      />
      
      {/* 선생님 전용 대시보드 */}
      <Route 
        path="/teachers" 
        element={<TeacherDashboard />} 
      />

      {/* 메인페이지 테스트 */}
      <Route
        path="/main-test"
        element={<MainTestPage />}
      />
      
      {/* 기본 경로를 메인으로 리다이렉트 */}
      <Route 
        path="*" 
        element={<Navigate to="/" replace />} 
      />
    </Routes>
  );

  return (
    <div className={`App ${isMainTestPage ? 'main-test' : ''}`}>
      {isMainTestPage ? (
        routes
      ) : (
        <div className="app-container">
          <h1 className="app-title">
            <img src="/Wonderland_Logo.png" alt="Wonderland Logo" style={{ width: '70px', height: '70px' }} />
            순천 Wonderland
          </h1>
          {routes}
        </div>
      )}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
